import React ,{ useState , useEffect }from 'react';
import SearchBodySearchBoxSearchBar from './SearchBodySearchBoxSearchBar';
import webapi from '../../../api/webapi';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../css/react-tabs2.css';
import Loading from '../modal/Loading';


const SearchBodySearchBox = (props) => {

    const [bookGroups,setBookGroups] = useState(undefined);
    const [books,setBooks] = useState(undefined);
    const [chapters,setChapters] = useState(undefined);

    //const [selectedBookGroup,setSelectedBookGroup] = useState(undefined);
    //const [selectedBook,setSelectedBook] = useState(undefined);
    //const [selectedChapter,setSelectedChapter] = useState('All');

    const [bookGroupShowAll,setBookGroupShowAll] = useState(false);
    const [bookShowAll,setBookShowAll] = useState(true);
    const [chapterShowAll,setChapterShowAll] = useState(true);

    const [loadingShow,setLoadingShow] = useState(false);
    const [tabIndex,setTabIndex] = useState(0);
    // const [showInClass,setShowInClass] = useState(undefined);

    useEffect(()=>{
        async function GetBookGroups () {
            var bookGroupsVar = ''
            await webapi.get('surf/allbookgroups/' + props.lang)
                .then(response => {
                    bookGroupsVar = response.data;
                    setBookGroups(bookGroupsVar);
                })
            if (bookGroupsVar && bookGroupsVar.length > 0)
            {
                if (bookGroupShowAll)
                {
                    props.setSelectedBookGroup('All');
                    GetBooks('All');
                }
                else
                {
                    props.setSelectedBookGroup(bookGroupsVar[0].Code);
                    GetBooks(bookGroupsVar[0].Code);
                }
            }
            else
            {
                props.setSelectedBook('');
                props.setSelectedChapter('')
            }
        }

        setLoadingShow(true)
        // setSelectedBook(undefined);
        // setSelectedBookGroup(undefined);
        // setSelectedChapter(undefined);

        setBookGroupShowAll(false);
        setBookShowAll(true);
        setChapterShowAll(true);

        GetBookGroups();

        setLoadingShow(false)
    },[]);


    const GetBooks = async (bookGroupCode) =>{
        setLoadingShow(true)

        var booksVar = ''
        //console.log('surf/bookgroupsbook/' + bookGroupCode + '/' + props.lang);
        await webapi.get('surf/bookgroupsbook/' + bookGroupCode + '/' + props.lang)
            .then(response => {
                booksVar = response.data
                setBooks(booksVar);
            })
       
        if (booksVar && booksVar.length > 0)
        {
            if (bookShowAll)
            {
                props.setSelectedBook('All');
                setChapters(undefined);
                props.setSelectedChapter('All')
                //GetChapters('All');
            }
            else
            {
                props.setSelectedBook(booksVar[0].Code)
                GetChapters(booksVar[0].Code)
            }
        }
        else
        {
            props.setSelectedBook('')
            props.setSelectedChapter('')
        }  
        
        setLoadingShow(false)              
    }

    const GetChapters = async (BookCode) =>{
        setLoadingShow(true)
        var chapterVar = ''
        if (BookCode !== 'All') {
            await webapi.get('surf/bookschapter/'+ BookCode+'/' + props.lang)
                .then(response => {
                    chapterVar = response.data
                    setChapters(chapterVar);
                })

            if (chapterVar && chapterVar.length > 0)
            {
                if (chapterShowAll)
                {
                    props.setSelectedChapter('All');
                }
                else
                {
                    props.setSelectedChapter(chapterVar[0].Code)
                }            
            }
            else
            {
                props.setSelectedChapter('');
            }
        }
        else
        {
            setChapters(undefined);
            props.setSelectedChapter('All');
        }
        setLoadingShow(false)        
    }

    const onChangeBookGroupSelect = async (event) => {
        setLoadingShow(true)
        //setState({ results: '' });
        props.setSelectedBookGroup(event.target.value);
        props.onSearchBoxChanged();
        
        GetBooks(event.target.value);
    };

    const onChangeBookSelect = async event => {
        setLoadingShow(true)
        //setState({ results: '' });
        props.setSelectedBook(event.target.value);
        props.onSearchBoxChanged();

        GetChapters( event.target.value );
    };

    const onChangeChapterSelect = async event => {
        //setState({ results: '' });
        props.setSelectedChapter(event.target.value)
        props.onSearchBoxChanged();
    };

    const onSelectTab = (tabIndex)=>{
        //console.log(tabIndex);
        setTabIndex(tabIndex);
        props.onSelectTab(tabIndex);
    }

    
    return (
        <div className="container-fluid" id="words_search_form">
            <Loading loadingShow={loadingShow} />
            <div className="container">
                <br />
                {
                    //console.log("tabIndexChild", tabIndex)
                    //console.log("SelectedBookInSearchBox", SelectedBook)
                }
                {//alert("ren:"+SelectedBook)
                }
                <div className="select_param">           
                    <label>{props.pageData.length!==0 && props.pageData[0].F20201!== undefined ? props.pageData[0].F20201:20201/*نوع متن*/}</label>
                    <select className="" id='select' onChange={onChangeBookGroupSelect}>
                        {   
                            bookGroups 
                            ?
                            bookGroups.map((bookgroup,i) =>{
                                return  (
                                    [
                                        (((bookGroups.length>1) && (i===0)) && (bookGroupShowAll))
                                        ?
                                        <option key={"BookGroupAll"} value="All" select="true">{ props.pageData.length!==0 && props.pageData[0].F29902!== undefined?props.pageData[0].F29902:29902/*همه*/}</option>
                                        :
                                        null
                                        ,
                                        <option key={bookgroup.Code} value={bookgroup.Code}>{bookgroup.Title}</option> 
                                    ]
                                )
                            })
                            :
                            <option key="-1">-</option>       
                        }
                    </select>
                </div>
                <div className="select_param"> 
                    { 
                        (props.selectedBookGroup==="2")
                        ?
                        <label>{props.pageData.length!==0 && props.pageData[0].F20204!== undefined?props.pageData[0].F20204:20204/*نوع کتیبه*/}</label>
                        :
                        <label>{props.pageData.length!==0 && props.pageData[0].F20201!== undefined?props.pageData[0].F20201:20201/*نام متن*/}</label>
                    }          
                    <select onChange={onChangeBookSelect} className="">
                        {   
                            books != null 
                            ?
                            books.map((book,i) =>{
                                return  (
                                    [
                                        (((books.length>1) && (i===0)) && (bookShowAll))
                                        ?
                                        <option key={"BookAll"} value="All" select="true">{props.pageData.length!==0 && props.pageData[0].F29902!== undefined?props.pageData[0].F29902:29902/*همه*/}</option>
                                        :
                                        null
                                        ,
                                        <option key={book.Code} value={book.Code}>{book.Title}</option> 
                                    ]
                                )
                            })
                            :
                            <option key="-1">-</option>       
                        }
                    </select>
                </div>
                <div className="select_param"> 
                    { 
                        (props.selectedBookGroup==="2")
                        ?
                        <label>{props.pageData.length!==0 && props.pageData[0].F20205!== undefined?props.pageData[0].F20205:20205/*نام کتیبه*/}</label>
                        :
                        <label>{props.pageData.length!==0 && props.pageData[0].F20203!== undefined?props.pageData[0].F20203:20203/*شماره فصل*/}</label>
                    }
                    <select onChange={onChangeChapterSelect}  className="">
                        {   
                            chapters != null 
                            ?
                            chapters.map((chapter,i) =>{
                                return  (
                                    [
                                        (((chapters.length>1) && (i===0)) && (chapterShowAll))
                                        ?
                                        <option key={"ChapterAll"} value="All" select="true">{props.pageData.length!==0 && props.pageData[0].F29902!== undefined?props.pageData[0].F29902:29902/*همه*/}</option>
                                        :
                                        null
                                        ,
                                        <option key={chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                    ]
                                )
                            })
                            :
                            <option key="-1">-</option>       
                        }
                    </select>
                </div>
                <br />
                { //console.log('SearchBodySearchBox=>selectedBookGroup:',props.selectedBookGroup) 
                }
                <Tabs   className ="search-tab" 
                        selectedTabPanelClassName="search_tab-panel--selected" 
                        selectedTabClassName="search_tab--selected"
                        disabledTabClassName="search_tab--disabled"
                        selectedIndex={tabIndex} 
                        //onSelect={tabIndex => setState({ tabIndex })}
                        onSelect={(tabIndex ) => onSelectTab(tabIndex)} 
                >
                    
                    <a href="/#" name={"Head"}> </a>
                    <TabList className="search-tab-list">
                        <Tab className ="search_tab">   {
                                                            props.selectedBookGroup === '5'
                                                            ?
                                                            props.pageData.length!==0 && props.pageData[0].F20225!== undefined?props.pageData[0].F20225:20225/*مانوی*/
                                                            :
                                                            props.pageData.length!==0 && props.pageData[0].F20214!== undefined?props.pageData[0].F20214:20214/*پهلوی*/
                                                        }
                        </Tab>
                        <Tab className ="search_tab">{props.pageData.length!==0 && props.pageData[0].F20210!== undefined?props.pageData[0].F20210:20210/*آوانویسی*/}</Tab>
                        <Tab className ="search_tab">{props.pageData.length!==0 && props.pageData[0].F20211!== undefined?props.pageData[0].F20211:20211/*حرف نویسی*/}</Tab>
                        <Tab className ="search_tab">{props.pageData.length!==0 && props.pageData[0].F20212!== undefined?props.pageData[0].F20212:20212/*معنی فارسی*/}</Tab>
                        <Tab className ="search_tab">{props.pageData.length!==0 && props.pageData[0].F20213!== undefined?props.pageData[0].F20213:20213/*بن واژه*/}</Tab>
                    </TabList>                    
                    <TabPanel className ="search_tab-panel" >
                        <SearchBodySearchBoxSearchBar
                            onSearchButtonClick={props.onSearchButtonClick} 
                            selectedBookGroup={props.selectedBookGroup} 
                            selectedBook={props.selectedBook} 
                            selectedChapter={props.selectedChapter}

                            setSelectedBookGroup = {props.setSelectedBookGroup}
                            setSelectedBook = {props.setSelectedBook}
                            setSelectedChapter = {props.setSelectedChapter}

                            placeHolder={
                                props.selectedBookGroup === '5'
                                ?
                                props.pageData.length!==0 && props.pageData[0].F20226!== undefined?props.pageData[0].F20226:20226/*جستجوی مانوی*/
                                :
                                props.pageData.length!==0 && props.pageData[0].F20224!== undefined?props.pageData[0].F20224:20224/*"جستجوی پهلوی"*/
                            }

                            word={props.word}
                            setWord = {props.setWord}

                            showInClass={props.selectedBookGroup==='5'?"Manavi":"Pahlavi"}
                            pageData={props.pageData}
                        />
                        {/*تعداد {statments.length} عبارت پیدا شد*/}
                    </TabPanel>
                    <TabPanel className ="search_tab-panel">
                        <SearchBodySearchBoxSearchBar
                                    onSearchButtonClick={props.onSearchButtonClick}

                                    selectedBookGroup={props.selectedBookGroup} 
                                    selectedBook={props.selectedBook} 
                                    selectedChapter={props.selectedChapter}

                                    setSelectedBookGroup = {props.setSelectedBookGroup}
                                    setSelectedBook = {props.setSelectedBook}
                                    setSelectedChapter = {props.setSelectedChapter}

                                    placeHolder={props.pageData.length!==0 && props.pageData[0].F20220!== undefined?props.pageData[0].F20220:20220/*"جستجوی آوانویسی"*/}
                                    
                                    word={props.word}
                                    setWord = {props.setWord}

                                    showInClass={"Phonetic"}
                                    pageData={props.pageData}
                        />
                        {/*تعداد {statments.length} عبارت پیدا شد*/}
                    </TabPanel>
                    <TabPanel className ="search_tab-panel">
                        <SearchBodySearchBoxSearchBar
                                    onSearchButtonClick={props.onSearchButtonClick}  
                                    selectedBookGroup={props.selectedBookGroup} 
                                    selectedBook={props.selectedBook} 
                                    selectedChapter={props.selectedChapter}

                                    setSelectedBookGroup = {props.setSelectedBookGroup}
                                    setSelectedBook = {props.setSelectedBook}
                                    setSelectedChapter = {props.setSelectedChapter}

                                    placeHolder={props.pageData.length!==0 && props.pageData[0].F20221!== undefined?props.pageData[0].F20221:20221/*"جستجوی حرف نویسی"*/}

                                    word={props.word}
                                    setWord = {props.setWord}

                                    showInClass={"english"}
                                    pageData={props.pageData}
                        />
                    </TabPanel>
                    <TabPanel className ="search_tab-panel">
                        
                        <SearchBodySearchBoxSearchBar
                                    onSearchButtonClick={props.onSearchButtonClick}  
                                    selectedBookGroup={props.selectedBookGroup} 
                                    selectedBook={props.selectedBook} 
                                    selectedChapter={props.selectedChapter}

                                    setSelectedBookGroup = {props.setSelectedBookGroup}
                                    setSelectedBook = {props.setSelectedBook}
                                    setSelectedChapter = {props.setSelectedChapter}

                                    placeHolder={props.pageData.length!==0 && props.pageData[0].F20222!== undefined?props.pageData[0].F20222:20222/*"جستجوی معنی فارسی"*/}
                                    
                                    word={props.word}
                                    setWord = {props.setWord}

                                    showInClass={"farsi"}
                                    pageData={props.pageData}
                        />
                    </TabPanel>
                    <TabPanel className ="search_tab-panel">
                        <SearchBodySearchBoxSearchBar
                                    onSearchButtonClick={props.onSearchButtonClick}  
                                    selectedBookGroup={props.selectedBookGroup} 
                                    selectedBook={props.selectedBook} 
                                    selectedChapter={props.selectedChapter}

                                    setSelectedBookGroup = {props.setSelectedBookGroup}
                                    setSelectedBook = {props.setSelectedBook}
                                    setSelectedChapter = {props.setSelectedChapter}

                                    placeHolder={props.pageData.length!==0 && props.pageData[0].F20223!== undefined?props.pageData[0].F20223:20223/*"جستجوی بن واژه"*/}

                                    word={props.word}                                    
                                    setWord = {props.setWord}

                                    showInClass={"Phonetic"}
                                    pageData={props.pageData}
                        />
                    </TabPanel>
                </Tabs>
                
            </div>
        </div>
    )
}

export default SearchBodySearchBox;